import {WidgetData} from '../../../core/shared/widget/widget-data';
import {WidgetFactory} from '../../../core/shared/widget/service/widget.factory';
import {FilterCriteria} from '../../../core/shared/filter/api/filter.criteria';
import {Sorting} from '../../../core/shared/misc/sorting';
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from '../../../core/shared/helper/widget-function-call-back-create';

/**
 * Alias of the "Dokumentrollen" child widget of a request type (CONFIG-011: exactly ONE alias
 * across every state of the widget).
 */
export const CW_REQUEST_TYPE_DOCUMENT_ROLE_WIDGET_ALIAS = 'config.cw.CwRequestTypeDocumentRole.widget';

/**
 * Builds the "Dokumentrollen" child table of one {@code cw.CwRequestType} (T3 FE-09).
 *
 * These rows are not just a taxonomy: the mandatory {@code description} is the prompt text the
 * document classifier is given, and the row is also the target of
 * {@code cw.CwCaseTypeDocumentType.requestSource}. An incomplete catalogue therefore degrades the
 * classification silently — it does not fail.
 *
 * TRAP CONFIG-012: the parent FK is pre-set on CREATE via {@code onFunctionCreateNew}.
 *
 * @param requestTypeId id of the selected parent {@code cw.CwRequestType}.
 */
export function buildCwRequestTypeDocumentRoleWidget(requestTypeId: number): WidgetData {
    /**
     * AI:
     * Status: "in progress"
     * Type: Widget
     * SubType: Runtime
     * Reason: Child table of one CwRequestType's Dokumentrollen catalogue, parent FK pre-set on
     *   CREATE via WidgetFunctionCallBackCreate (CONFIG-012).
     */
    const widgetData = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
        CW_REQUEST_TYPE_DOCUMENT_ROLE_WIDGET_ALIAS,
        'Dokumentrollen',
        'cw.CwRequestTypeDocumentRole',
        [FilterCriteria.create('e.requestTypeId', FilterCriteria.cOperatorEqual, requestTypeId)],
        [new Sorting('e.orderPriority', true)]
    );
    widgetData.noDataText = 'Keine Dokumentrollen für diesen Antragstyp konfiguriert';

    const fields: WidgetToolbarCreateInterface[] = [{fieldName: 'requestTypeDtoId', fieldValue: requestTypeId}];
    widgetData.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);

    return widgetData;
}
